var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4922 11.9805C23.4922 12.6836 22.9062 13.2344 22.2422 13.2344H20.9922L21.0195 19.4883C21.0195 19.5977 21.0117 19.6992 21 19.8047V20.4375C21 21.3008 20.3008 22 19.4375 22H18.8125C18.7695 22 18.7266 21.9648 18.6836 21.9961C18.6289 21.9648 18.5742 22 18.5195 22H16.3125C15.4492 22 14.75 21.3008 14.75 20.4375V17C14.75 16.3086 14.1914 15.75 13.5 15.75H11C10.3086 15.75 9.75 16.3086 9.75 17V20.4375C9.75 21.3008 9.05078 22 8.1875 22H6.00391C5.94531 22 5.88672 21.9961 5.82812 21.9922C5.78125 21.9961 5.73438 22 5.6875 22H5.0625C4.19961 22 3.5 21.3008 3.5 20.4375V16.0625C3.5 16.0273 3.50117 15.9883 3.50352 15.9531V13.2344H2.25195C1.54766 13.2344 1 12.6836 1 11.9805C1 11.6289 1.11734 11.3164 1.39102 11.043L11.4062 2.31312C11.6797 2.03914 11.9922 2 12.2656 2C12.5391 2 12.8516 2.07828 13.0898 2.27398L23.0625 11.043C23.375 11.3164 23.5352 11.6289 23.4922 11.9805Z",
    fill: "#FF7B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.3cc570713f597d01e0edf0fb6393a447.svg";
export { ForwardRef as ReactComponent };